import { ReactElement } from 'react'
import PaymentMethodList from '../components/PaymentMethod'
import Layout from '../components/layout'

const PaymentMethodPage = (): ReactElement => {
  return (
    <Layout >
      <PaymentMethodList />
    </Layout>
  )
}

export default PaymentMethodPage
